import { useCallback } from 'react';

// Global cache for positions to be shared across all components
const globalPositionsCache = new Map<string, { id: string; name: string }>();

export function usePositionsCache() {
  const addPositionToCache = useCallback(
    (
      accountSlug: string,
      brandId: string,
      position: { id: string; name: string },
    ) => {
      const cacheKey = `${accountSlug}-${brandId}-${position.id}`;
      globalPositionsCache.set(cacheKey, {
        id: position.id,
        name: position.name,
      });
    },
    [],
  );

  const getPositionFromCache = useCallback(
    (accountSlug: string, brandId: string, positionId: string) => {
      const cacheKey = `${accountSlug}-${brandId}-${positionId}`;
      return globalPositionsCache.get(cacheKey) ?? null;
    },
    [],
  );

  const clearCache = useCallback(() => {
    globalPositionsCache.clear();
  }, []);

  return {
    addPositionToCache,
    getPositionFromCache,
    clearCache,
  };
}
